import React from 'react';
import { ITrackingLink } from '../trackingLinks';
import { Box, Divider, Grid, Paper, styled, Typography } from '@mui/material';

interface FieldProps {
    label: string;
    children: React.ReactNode;
}
const Field = ({ label, children }: FieldProps) => (
    <Box display="flex" flexDirection="column" gap={0.5}>
        <Typography variant="caption" color="text.secondary">
            {label}
        </Typography>
        <Box>{children}</Box>
    </Box>
);

const MonoText = styled(Typography)({
    fontFamily: 'monospace',
    wordBreak: 'break-all'
});

const CardHeader = styled(Box)(({ theme }) => ({
    padding: theme.spacing(1),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    height: 46,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
}));

const EM_DASH = '—';

interface UTMDetailsProps {
    trackingLink: ITrackingLink;
}

export const UTMDetails = ({ trackingLink }: UTMDetailsProps) => {
    const hasUtmParams = React.useMemo(
        () =>
            trackingLink.utmSource ||
            trackingLink.utmMedium ||
            trackingLink.utmCampaign ||
            trackingLink.utmContent ||
            trackingLink.utmTerm,
        [trackingLink]
    );
    return (
        <Paper elevation={0} sx={{ border: '1px solid', borderColor: 'divider' }}>
            <CardHeader>
                <Typography variant="h6">UTM Parameters</Typography>
            </CardHeader>
            <Divider />
            <Box padding={2}>
                {hasUtmParams && (
                    <Grid container spacing={2}>
                        <Grid size={4}>
                            <Field label="Source">
                                <MonoText variant="body2">{trackingLink.utmSource || EM_DASH}</MonoText>
                            </Field>
                        </Grid>
                        <Grid size={4}>
                            <Field label="Medium">
                                <MonoText variant="body2">{trackingLink.utmMedium || EM_DASH}</MonoText>
                            </Field>
                        </Grid>
                        <Grid size={4}>
                            <Field label="Campaign">
                                <MonoText variant="body2">{trackingLink.utmCampaign || EM_DASH}</MonoText>
                            </Field>
                        </Grid>
                        <Grid size={4}>
                            <Field label="Content">
                                <MonoText variant="body2">{trackingLink.utmContent || EM_DASH}</MonoText>
                            </Field>
                        </Grid>
                        <Grid size={4}>
                            <Field label="Term">
                                <MonoText variant="body2">{trackingLink.utmTerm || EM_DASH}</MonoText>
                            </Field>
                        </Grid>
                    </Grid>
                )}
                {!hasUtmParams && (
                    <Typography variant="body2" color="text.secondary">
                        No UTM parameters attached to this link
                    </Typography>
                )}
            </Box>
        </Paper>
    );
};
